export enum Color {
  BgLightPrimary = '#D7EAFF',
  BgLightPrimarySelected = '#EFF8FF',

  Primary = '#3380EF',

  Black = '#000000',
  White = '#fff',
  Green = '#1B9524',
  Gray = '#2c2b2e',
  LightBlue = '#3B82F6',
  DarkBlue = '#0F2744',
  SidebarBg = '#F7F8FA',
  TopLoader = '#FFB800',
  TableHeader = '#F3F5F9',
  TableHeaderColor = '#728095',
}

export const STATUS_COLOR = {
  ACHIEVED: '#1D960C',
  ON_TRACK: '#4FDFFF',
  AT_RISK: '#FF0000',
  AHEAD: '#009AF0',
  BEHIND: '#FFAE10',
  BELOW_TARGET: '#FFAE10',
  NOT_STARTED: '#B2B2B2',
  APPROVED: 'green',
  REJECTED: 'error',
  PENDING: 'warning',
  ARCHIVED: 'default',
};

export const AVERAGE_STATUS_COLOR = {
  BELOW_TARGET: '#FF0000',
  AT_RISK: '#FFAE10',
  ON_TARGET: '#084F9E',
};

export const ENTITY_STATUS_COLOR = {
  Operating: '#1B9524',
  Not_Operating: '#B2B2B2',
};
